import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useTheme } from "../components/Theme/Themecontext";

const CeoDashboardCircle = ({ total, values = [], sum }) => {
  const { styles,theme,isSystemLight } = useTheme();
  const { component, blacktext } = styles;
  const { t, i18n } = useTranslation();
  const [radius, setRadius] = useState(70);
  const [stroke, setStroke] = useState(20);

  const updateDimensions = () => {
    const width = window.innerWidth;

    if (width <= 640) {
      setRadius(55);
      setStroke(10);
    } else if (width > 640 && width <= 1024) {
      setRadius(55);
      setStroke(10);
    } else {
      setRadius(55);
      setStroke(10);
    }
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const circumference = 2 * Math.PI * radius;
  const normalizedRadius = radius - stroke / 2;
  const calculateSegments = (values, total) => {
    let segments = [];
    let cumulativeLength = 0;

    values.forEach((value, index) => {
      if (value !== 0) {
        const segmentLength = (value / total) * circumference;
        const angle = (cumulativeLength / circumference) * 360 + 90;
        const textAngle = angle + ((segmentLength / circumference) * 580) / 2;

        const textX =
          radius + normalizedRadius * Math.cos((textAngle * Math.PI) / 180);
        const textY =
          radius + normalizedRadius * Math.sin((textAngle * Math.PI) / 180);

        segments.push({
          length: segmentLength,
          color: getColor(index),
          offset: cumulativeLength,
          value: value,
          textX: textX,
          textY: textY,
          angle: angle,
        });

        cumulativeLength += segmentLength;
      }
    });

    return segments;
  };

  const getColor = (index) => {
    const colors = ["#008000", "#FFA500", "#767676"];
    return colors[index];
  };

  const indicators = [
    { color: "#008000", label: "clockedinfromoffice" },
    { color: "#FFA500", label: "clockedinfromremote" },
    { color: "#767676", label: "notyetclockedin" },
  ];

  const segments = calculateSegments(values, total);

  return (
    <div style={component} className="relative h-[155px] md:w-[350px] rounded-[10px] p-2">
      <div className="flex items-center justify-between">
        <div className="flex-1 text-center">
          <p style={blacktext} className="font-semibold text-[10px] md:text-[14px]">
            {t('totalworkforce')}
          </p>
        </div>
        <Link to="/home/dashboard">
          <div className="cursor-pointer">
            <span style={blacktext} className="material-symbols-outlined !text-[16px]">
              more_vert
            </span>
          </div>
        </Link>
      </div>

      <div className="flex  justify-evenly items-center">
        {/* SVG Circle Container */}
        <div style={blacktext} className="relative w-[110px] h-[110px]">
          <svg width="100%" height="100%" viewBox="0 0 110 110">
            {segments.map((segment, index) => (
              <g key={index}>
                <circle
                  cx="55"
                  cy="55"
                  r={normalizedRadius}
                  stroke={segment.color}
                  strokeWidth={stroke}
                  fill="none"
                  strokeDasharray={`${segment.length} ${circumference}`}
                  strokeDashoffset={-segment.offset}
                  transform="rotate(90 55 55)"
                />
                <text
                  x={segment.textX}
                  y={segment.textY}
                  textAnchor="middle"
                  className="text-[5px] md:text-[8px] font-semibold"
                  fill="#ffffff"
                >
                  {segment.value}
                </text>
              </g>
            ))}
            
            {/* Center Text - Correctly Centered */}
            <text fill={theme === "dark" || (theme === "system" && !isSystemLight) ? "white" : "black"} style={blacktext}  x="55" y="52" textAnchor="middle" className="text-[12px] md:text-[14px] font-semibold">
              {sum}/{total}
            </text>
            <text  fill={theme === "dark" || (theme === "system" && !isSystemLight) ? "white" : "black"} style={blacktext}  x="55" y="65" textAnchor="middle" className="text-[8px] md:text-[9px] font-semibold">
              {t('attendancestatus')}
            </text>
          </svg>
        </div>

        {/* Indicators */}
        <div className="flex flex-col ml-2">
          {indicators.map((indicator, index) => (
            <div key={index} className="flex items-center mb-[5px]">
              <div
                className="rounded-full mr-1"
                style={{
                  backgroundColor: indicator.color,
                  height: "10px",
                  width: "10px",
                }}
              ></div>
              <p className="text-[10px]">{t(indicator.label)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CeoDashboardCircle;